import * as React from "react";
import type { SVGProps } from "react";
const SvgHeartFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 21a1 1 0 0 1-.7-.29L3.81 13.3A6 6 0 0 1 12 4.54a6 6 0 0 1 8.79 8.09 6 6 0 0 1-.6.67.2.2 0 0 1-.07.07l-7.42 7.35a1 1 0 0 1-.7.28"
    />
  </svg>
);
export default SvgHeartFilled;
